import React from "react";
import { object, array, string, number } from "prop-types";
import get from "lodash/get";
import cx from "classnames";
import { connect } from "react-redux";
import { ResponsiveHeroImage, ResponsiveImage, WithLazy } from "@quintype/components";
import "./card-image.m.css";
const CardImage = ({ story = {}, aspectRatio, defaultWidth, imageType = "image16x9", widths = [250, 480, 764] }) => {
  const wrapperStyleName = cx(
    "qt-image-dynamic",
    { image16x9: imageType === "image16x9" },
    { image4x3: imageType === "image4x3" },
    { image1x1: imageType === "image1x1" },
    { image302x403: imageType === "image302x403" },
    { image1x2: imageType === "image1x2" },
    { image9x16: imageType === "image9x16" },
  );
  const imgURL = story["hero-image-url"];
  const imgS3keys= story["hero-image-s3-key"];
  if (typeof window === "undefined") {
    return <figure styleName={wrapperStyleName} className={wrapperStyleName}>
    {imgURL ? <img styleName="image" className="image" src={imgURL} />:
    <ResponsiveImage
      slug={imgURL}
      metadata={story["hero-image-metadata"]}
      aspectRatio={aspectRatio}
      defaultWidth={defaultWidth}
      widths={widths}
      styleName="image"
      className="image"
      alt={story["hero-image-caption"] && story["hero-image-caption"]}
    />}
  </figure>
  }
  return (
    <WithLazy margin="50px">
      {() => (
        <figure styleName={wrapperStyleName} className={wrapperStyleName}>
          {imgURL ? <img styleName="image" className="image" src={imgURL} />:
          <ResponsiveHeroImage
            story={story }
            aspectRatio={aspectRatio}
            defaultWidth={defaultWidth}
            widths={widths}
            styleName="image"
            className="image"
            alt={story["hero-image-caption"] && story["hero-image-caption"]}
         />}
        </figure>
      )}
    </WithLazy>
  );
};
CardImage.propTypes = {
  story: object,
  aspectRatio: array,
  defaultWidth: number,
  imageType: string,
  widths: array
};
function mapStateToProps(state) {
  return {
    defaultImage: get(state, ["qt", "config", "publisher-attributes", "defaultImageKey"], "")
  };
}
export default connect(mapStateToProps, () => ({}))(CardImage);
